import { DateTime } from "luxon";

const toZonedDateTime = (date: Date, eventTimezone?: string | null): DateTime => {
  const dateTime = DateTime.fromJSDate(date);
  return eventTimezone ? dateTime.setZone(eventTimezone) : dateTime;
};

export function useCampaignDateRangeLabel(
  startDateUtc: Date | undefined,
  endDateUtc: Date | undefined,
  eventTimezone?: string | null
): string | null {
  if (!startDateUtc) {
    return null;
  }
  const start = toZonedDateTime(startDateUtc, eventTimezone);

  if (!endDateUtc) {
    return start.toFormat("LLL d, yyyy");
  }
  const end = toZonedDateTime(endDateUtc, eventTimezone);

  // Same date
  if (start.hasSame(end, "day")) {
    return start.toFormat("LLL d, yyyy");
  }

  // Same month and year
  if (start.hasSame(end, "month") && start.hasSame(end, "year")) {
    const startDay = start.day;
    const endDay = end.day;
    return `${start.toFormat("LLL")} ${startDay} - ${endDay}, ${start.year}`;
  }

  // Same year
  if (start.hasSame(end, "year")) {
    const startFormatted = start.toFormat("LLL d");
    const endFormatted = end.toFormat("LLL d, yyyy");
    return `${startFormatted} - ${endFormatted}`;
  }

  // Different years
  const startFormatted = start.toFormat("LLL d, yyyy");
  const endFormatted = end.toFormat("LLL d, yyyy");
  return `${startFormatted} - ${endFormatted}`;
}
